import React, { useState } from "react";
import Image from "next/image";

import defaultImage from "../../../../public/images/image20.jpeg";
import bgImg from "../../../../public/images/t19bg.png";

type Props = {
  sectionImage?: string;
};

interface Person {
  id: number;
  name: string;
  role: string;
  picture: string;
}

interface PersonCardProps {
  person: Person;
}

const WeddingParty: React.FC<Props> = ({ sectionImage }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const staticData: Person[] = [
    {
      id: 1,
      name: "Victoria Oke",
      role: "Maid of Honor",
      picture: "/images/weddingparty/victoriaMOH.jpg",
    },
    {
      id: 2,
      name: "Dumebi Iwuchukwu",
      role: "Best Man",
      picture: "/images/weddingparty/dumebiBMan.jpg",
    },
    {
      id: 3,
      name: "Fisayo Isa",
      role: "Chief Bridesmaid",
      picture: "/images/weddingparty/fisayoBM.jpg",
    },
    {
      id: 4,
      name: "Edikan Udoibout",
      role: "Groomsman",
      picture: "/images/weddingparty/edikanGM.jpg",
    },
    {
      id: 5,
      name: "Wumi Adeyemo",
      role: "Bridesmaid",
      picture: "/images/weddingparty/wumiBM.jpg",
    },
    {
      id: 6,
      name: "Kimberly Mupfukudzwa",
      role: "Bridesmaid",
      picture: "/images/weddingparty/kimberlyBM.jpg",
    },
    {
      id: 7,
      name: "Mmenim Essien",
      role: "Groomsman",
      picture: "/images/weddingparty/mmenimGM.jpg",
    },
    {
      id: 8,
      name: "Gloria Oke",
      role: "Bridesmaid",
      picture: "/images/weddingparty/gloriaBM.jpg",
    },
    {
      id: 9,
      name: "Damilola",
      role: "Bridesmaid",
      picture: "/images/weddingparty/damilolaBM.jpg",
    },
    {
      id: 10,
      name: "Ifeanyi Irele",
      role: "Groomsman",
      picture: "/images/weddingparty/ifeanyiGM.jpg",
    },
    {
      id: 11,
      name: "Shriya Cuppoor",
      role: "Bridesmaid",
      picture: "/images/weddingparty/shriyaBM.jpg",
    },
    {
      id: 12,
      name: "Efue Musah-Eroje",
      role: "Bridesmaid",
      picture: "/images/weddingparty/efueBM.jpg",
    },
    {
      id: 13,
      name: "Daniel Katchy",
      role: "Groomsman",
      picture: "/images/weddingparty/danielGM.jpg",
    },
    {
      id: 14,
      name: "Lolade Ogunseye",
      role: "Bridesmaid",
      picture: "/images/weddingparty/loladeBM.jpg",
    },
    {
      id: 15,
      name: "Nuel Richards",
      role: "Groomsman",
      picture: "/images/weddingparty/nuelGM.jpg",
    },
    {
      id: 16,
      name: "Pelumi Onasanya",
      role: "Bridesmaid",
      picture: "/images/weddingparty/pelumiBM.jpg",
    },
    {
      id: 17,
      name: "Peter Richards",
      role: "Groomsman",
      picture: "/images/weddingparty/peterGM.jpg",
    },
    {
      id: 18,
      name: "Syanne Joseph",
      role: "Bridesmaid",
      picture: "/images/weddingparty/syanneBM.jpg",
    },
  ];

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % staticData.length);
  };

  const handlePrevious = () => {
    setCurrentIndex(
      (prev) => (prev - 1 + staticData.length) % staticData.length
    );
  };

  const PersonCard: React.FC<PersonCardProps> = ({ person }) => (
    <div className="flex flex-col items-center text-center text-[#FCE2B0] max-w-md mx-auto">
      <div className="w-48 h-64 sm:w-56 sm:h-72 lg:w-64 lg:h-80 mb-6 rounded-lg overflow-hidden bg-gray-300 relative">
        <Image
          src={person.picture}
          alt={person.name}
          layout="fill"
          className="object-cover"
          sizes="(max-width: 768px) 192px, 256px"
        />
      </div>
      <h3 className="text-xl sm:text-2xl lg:text-3xl font-ntFab tracking-wide uppercase mb-2">
        {person.name}
      </h3>
      <p className="text-base sm:text-lg lg:text-xl font-ebGaramond italic text-[#FFF3DB]">
        {person.role}
      </p>
    </div>
  );

  return (
    <div className="w-full flex flex-col lg:flex-row lg:h-[100vh]">
      {/* Content Section - Takes natural height on mobile, centered on desktop */}
      <div className="w-full lg:flex-1 lg:h-full relative order-1 lg:order-2">
        {/* Background image */}
        <div className="absolute inset-0">
          <Image
            src={bgImg}
            alt="background"
            layout="fill"
            className="object-cover object-center"
          />
        </div>

        <div className="relative z-10 w-full h-full flex flex-col justify-center items-center py-12 lg:py-20 px-6 lg:px-10">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-ntFab text-[#FCE2B0] mb-4">
            The Wedding Party
          </h1>
          <p className="text-base sm:text-lg lg:text-xl font-ebGaramond text-[#FCE2B0] max-w-2xl mx-auto text-center mb-8 lg:mb-12">
            Meet the amazing people who will celebrate this special day with us.
          </p>

          {/* Person Card Display */}
          <div className="flex-1 flex items-center justify-center mb-8">
            <PersonCard person={staticData[currentIndex]} />
          </div>

          {/* Navigation Controls */}
          <div className="flex items-center justify-center gap-4 lg:gap-8">
            <button
              onClick={handlePrevious}
              className="w-10 h-10 lg:w-14 lg:h-14 border border-[#FCE2B0] text-[#FCE2B0] hover:bg-[#FCE2B0] hover:text-[#00234B] transition-all duration-300 rounded-full flex items-center justify-center"
            >
              <svg
                className="w-5 h-5 lg:w-6 lg:h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 19l-7-7 7-7"
                />
              </svg>
            </button>

            {/* Dots Indicator */}
            {/* <div className="flex gap-2">
              {staticData.map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setCurrentIndex(idx)}
                  className={`w-2 h-2 lg:w-3 lg:h-3 rounded-full transition-all duration-300 ${
                    idx === currentIndex
                      ? "bg-[#FCE2B0]"
                      : "bg-[#FCE2B0] opacity-40"
                  }`}
                />
              ))}
            </div> */}

            <button
              onClick={handleNext}
              className="w-10 h-10 lg:w-14 lg:h-14 border border-[#FCE2B0] text-[#FCE2B0] hover:bg-[#FCE2B0] hover:text-[#00234B] transition-all duration-300 rounded-full flex items-center justify-center"
            >
              <svg
                className="w-5 h-5 lg:w-6 lg:h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Image Section - Fixed height on mobile, follows content */}
      <div className="w-full h-[50vh] lg:flex-1 lg:h-full order-2 lg:order-1 lg:hidden">
        <div className="relative w-full h-full">
          <Image
            loading="eager"
            layout="fill"
            src={sectionImage || defaultImage}
            alt="wedding-party-image"
            className="object-cover object-center lg:object-top"
            sizes="(max-width: 1024px) 100vw, 50vw"
          />
        </div>
      </div>
    </div>
  );
};

export default WeddingParty;
